<div class="mb-3">
    <div class="table-header fw-bold py-2 d-flex flex-row flex-nowrap">
        <div class="col px-2" translate="CONFIRMATION_SUMMARY_MATERIAL_NO_LABEL"></div>
        <div class="d-none d-lg-block col-3 px-2" translate="CONFIRMATION_SUMMARY_DESCRIPTION_LABEL"></div>
        <div class="col px-2" translate="CONFIRMATION_SUMMARY_QUANTITY_LABEL"></div>
        <div class="col px-2" translate="CONFIRMATION_SUMMARY_MATERIAL_UNIT_LABEL"></div>
        <div class="d-none d-lg-block col-3 px-2" translate="CONFIRMATION_SUMMARY_MATERIAL_STATUS_LABEL"></div>
    </div>
    <ng-container *ngIf="materials.length > 0">
        <div *ngFor="let material of materials" class="table-row py-2">
            <div class="d-flex flex-row">
                <div class="col px-2">{{ material.materialIdentifier.materialNumber.value }}</div>
                <div class="d-none d-lg-block col-3 px-2">{{ material.description.value }}</div>
                <div class="col px-2">{{ material.quantity.value }}</div>
                <div class="col px-2">{{ material.quantityUnit.value }}</div>
                <div class="d-none d-lg-block col-3 px-2">
                    {{ material.consumptionCode.selectedEntry?.displayName }}
                </div>
            </div>
            <div class="d-block d-lg-none col-12 my-1">
                <div class="row">
                    <label class="col-4 px-2 col-form-label" translate="CONFIRMATION_SUMMARY_DESCRIPTION_LABEL"></label>
                    <div class="col-8 px-2">
                        <span class="form-control-plaintext">{{ material.description.value }}</span>
                    </div>
                    <label
                        class="col-4 px-2 col-form-label"
                        translate="CONFIRMATION_SUMMARY_MATERIAL_STATUS_LABEL"
                    ></label>
                    <div class="col-8 px-2">
                        <span class="form-control-plaintext">{{
                            material.consumptionCode.selectedEntry?.displayName
                        }}</span>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div *ngIf="materials.length === 0" class="table-row py-2">
        <div class="d-flex flex-row">
            <label class="col px-2" translate="CONFIRMATION_SUMMARY_MATERIAL_NOT_AVAILABLE"></label>
        </div>
    </div>
</div>
